import { Table } from "../../components/ui/table";
import { useEffect, useState } from "react";
import ViewIcon from "../../components/icons/view-icon";
import Modal from "../../components/ui/modal";
import CardDetail from "../../components/cardDetail/cardDetail";
import { getCardDetail, getCards, getCardsCount } from "src/firebase/admin.js";
import { doc, setDoc } from "firebase/firestore";
import { db } from "src/firebase/firebase";
import Loader from "../../components/loader";
import FilterIcon from "../../components/icons/filter-icon";
import Popover from "@mui/material/Popover";
import { useTranslation } from "react-i18next";
import { handleToastMessage } from "src/js/handleToastMessage";
import Button from "../../components/button";
import refreshImage from "../../assets/images/refresh.png";
import { dateSorting } from "src/js/sorting";
import Input from "../../components/input";
import ActivationTimer from "../../components/activationTImer";
import { Pagination } from "@mui/material";
import OverlayLoader from "../../components/overlayLoader";
import editIcon from "../../assets/images/editing.png";
import { useNavigate } from "react-router-dom";
const pageSize = 200;

const UserManagementCard = () => {
  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);
  const [activeCardDetail, setActiveCardDetail] = useState(null);
  const [cardList, setCardList] = useState([]);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [filterCardList, setFilterCardList] = useState([]);
  const [status, setStatus] = useState("pending");
  const { t } = useTranslation(["home"]);
  const [totalCards, setTotalCards] = useState<number>(0);
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [searchText, setSearchText] = useState<string>("");

  useEffect(() => {
    getCardListCount();
  }, []);

  useEffect(() => {
    getCardList();
  }, [currentPage, searchText, status]);

  const getCardListCount = async () => {
    let result: any = await getCardsCount("", status);

    setTotalCards(result);
  };

  const getCardList = async () => {
    setIsLoading(true);
    let result: any = await getCards(
      "",
      status,
      currentPage,
      pageSize,
      searchText
    );
    result = result.map((item) => {
      return {
        ...item,
        name: item?.account?.firstName + " " + item?.account?.lastName,
      };
    });
    setIsLoading(false);
    const _cards = dateSorting(result ?? [], "date");
    setCardList(_cards);
    setFilterCardList(_cards);
  };
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;

  const changeStatus = async (status, data) => {
    let _data = data;
    _data.status = status;
    await setDoc(doc(db, "Cards", _data.id), _data);
  };
  const updateAssignee = async (data) => {
    let _acccount = await localStorage.getItem("account");
    let _data = data;
    _data.assignee = JSON.parse(_acccount);

    // await setDoc(doc(db, "Cards", _data.id), _data);
    // getCardList();

    let _detail = await getCardDetail(_data.id);
    if (_detail.length > 0) {
      if (_detail[0]?.assignee) {
        handleToastMessage("error", "Card is already assigned.");
      } else {
        await setDoc(doc(db, "Cards", _data.id), _data);
      }
    }
    await getCardList();
  };
  const getStatusCardList = async (status) => {
    setStatus(status);
    handleClose();
  };
  const handleCardSearch = (value) => {
    setSearchText(value);
    setCurrentPage(1);
  };

  const navigate = useNavigate();
  const columns = [
    // {
    //   title: (
    //     <div className="pl-1 flex justify-between items-center">
    //       <span>{t("ID")}</span>
    //     </div>
    //   ),
    //   dataIndex: "id",
    //   key: "id",
    //   width: 200,
    // },
    {
      title: (
        <div className="pl-1 flex justify-between items-center">
          <span>{t("User Name")}</span>
        </div>
      ),
      dataIndex: "name",
      key: "name",
      width: 200,
      render: (name: string) => <div>{name}</div>,
    },
    {
      title: (
        <div className="pl-1 flex justify-between items-center">
          <span>{t("Card No")}</span>
        </div>
      ),
      dataIndex: "cardNo",
      key: "cardNo",
      width: 200,
      render: (cardNo: string) => <div>{cardNo}</div>,
    },
    {
      title: (
        <div className="pl-1 flex justify-between items-center">
          <span>Cvv</span>
        </div>
      ),
      dataIndex: "cvv",
      key: "cvv",
      width: 200,
    },
    {
      title: (
        <div className="pl-1 flex justify-between items-center">
          <span>{t("MM/YY")}</span>
        </div>
      ),
      dataIndex: "mmyy",
      key: "mmyy",
      width: 200,
    },

    {
      title: (
        <div className="pl-1 flex justify-between items-center">
          <span>{t("Amount")}</span>
        </div>
      ),
      dataIndex: "amount",
      key: "amount",
      width: 200,
    },
    {
      title: (
        <div className="pl-1 flex justify-between items-center">
          <span>{t("Rate")}</span>
        </div>
      ),
      dataIndex: "rate",
      key: "rate",
      width: 200,
      render: (rate: string, row) => {
        return <div>{rate ?? row?.offering.rate}</div>;
      },
    },
    {
      title: (
        <div className="pl-1 flex justify-between items-center">
          <span>{t("Order")}</span>
        </div>
      ),
      dataIndex: "order",
      key: "order",
      width: 200,
    },

    {
      title: (
        <div className="pl-1 flex justify-between items-center">
          <span>{t("Direct Use")}</span>
        </div>
      ),
      dataIndex: "directUse",
      key: "directUse",
      width: 200,
      render: (directUse: boolean) => <div>{directUse ? "Yes" : "No"}</div>,
    },
    {
      title: (
        <div className="pl-1 flex justify-between items-center">
          <span>{t("Assign")}</span>
        </div>
      ),
      dataIndex: "assignee",
      key: "assignee",

      render: (assignee: any, row: any) => (
        <div>
          {assignee ? (
            <span>{`${assignee.firstName} ${assignee.lastName}`} </span>
          ) : (
            <span
              className="text-blue underline cursor-pointer"
              onClick={() => updateAssignee(row)}
            >
              {t("Assign me")}
            </span>
          )}
        </div>
      ),
      width: 200,
    },

    {
      title: (
        <div className="pl-1 flex justify-between items-center">
          <span>{t("Date")}</span>
        </div>
      ),
      dataIndex: "date",
      render: (date: any) => (
        <div>{date ? new Date(date.seconds * 1000).toDateString() : ""}</div>
      ),
      key: "date",
      width: 200,
    },
    {
      title: (
        <div className="pl-1 flex justify-between items-center">
          <span>{t("Activation time")}</span>
        </div>
      ),
      dataIndex: "activationTime",
      render: (activationTime: any) => (
        <div>
          {activationTime ? (
            <>
              <ActivationTimer expiryTimestamp={activationTime as number} />
            </>
          ) : (
            ""
          )}
        </div>
      ),
      key: "activationTime",
      width: 200,
    },
    {
      title: (
        <div className="pl-1 flex justify-between items-center">
          <span>{t("Status")}</span>
        </div>
      ),
      dataIndex: "status",
      key: "status",
      width: 200,
      render: (status: string, row: any) => (
        <div>
          {status === "pending activation" && (
            <span className="py-1 px-3 bg-warn text-warn-700 rounded inline-block w-[100px] text-center ">
              {t("Pending activation")}
            </span>
          )}
          {status === "pending" && (
            <span className="py-1 px-3 bg-warn text-warn-700 rounded inline-block w-[70px] text-center ">
              {t("Pending")}
            </span>
          )}
          {status === "paid" && (
            <span className="py-1 px-3 bg-success-100 text-success rounded inline-block w-[70px] text-center ">
              {t("Paid")}
            </span>
          )}
          {status === "declined" && (
            <span className="py-1 px-3 bg-red-100 text-red rounded inline-block text-center w-[70px]">
              {t("Declined")}
            </span>
          )}
        </div>
      ),
    },
    {
      title: (
        <div className="pl-1 flex justify-between items-center">
          <span>{t("Action")}</span>
        </div>
      ),
      dataIndex: "id",
      key: "id",
      width: 200,
      render: (id: string, row: any) => (
        <div className="flex gap-x-2">
          <ViewIcon
            className="cursor-pointer"
            onClick={() => setActiveCardDetail(row)}
          />
          <img
            src={editIcon}
            className="cursor-pointer"
            onClick={() => navigate(`/processing-team/new-card?id=${id}`)}
          />
        </div>
      ),
    },
  ];

  const handlePageChange = (
    event: React.ChangeEvent<unknown>,
    page: number
  ) => {
    console.log("value", page);
    setCurrentPage(page);
  };

  return (
    <div className="p-5">
      <div className="flex justify-between items-center mb-3">
        <h2 className="text-xl text-darkBlack font-semibold">
          {t("Users")} {t("Cards")} {t("Management")}
        </h2>
      </div>
      <div className="p-4 bg-white">
        <div className="flex justify-between items-center mb-3">
          <h1 className="text-darkGrey text-lg font-bold ">
            {t("Cards")} {t("List")}
          </h1>
          <div className="flex items-center gap-x-3">
            <div className="flex gap-2 items-center">
              <FilterIcon className="cursor-pointer" onClick={handleClick} />

              <Popover
                id={"id"}
                open={open}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={{
                  vertical: "bottom",
                  horizontal: "left",
                }}
                style={{ marginTop: "5px" }}
              >
                <div className="shadow p-2 bg-white w-[150px]">
                  <div className="flex flex-col">
                    <span
                      className="py-2 text-grey text-sm cursor-pointer"
                      onClick={() => getStatusCardList("")}
                    >
                      {t("All")}
                    </span>
                    <span
                      className="py-2 text-grey text-sm cursor-pointer"
                      onClick={() => getStatusCardList("pending")}
                    >
                      {t("Pending")}
                    </span>
                    <span
                      className="py-2 text-grey text-sm cursor-pointer"
                      onClick={() => getStatusCardList("paid")}
                    >
                      {t("Accepted")}
                    </span>
                    <span
                      className="py-2 text-grey text-sm cursor-pointer"
                      onClick={() => getStatusCardList("declined")}
                    >
                      {t("Declined")}
                    </span>
                  </div>
                </div>
              </Popover>

              {/* <Input
              name="keyword"
              placeholder="Search by keyword"
              inputClassName="h-9"
              variant="solid"
            /> */}
            </div>
            <Input
              name="search"
              placeholder="Search card"
              className="mb-3"
              onChange={(e) => handleCardSearch(e.target.value)}
            />
            <Button size="small" onClick={getCardList}>
              <img src={refreshImage} alt="" className="mr-2" />
              {t("Refresh")}
            </Button>
          </div>
        </div>
        {isLoading && <OverlayLoader />}
        <Table
          tableLayout="fixed"
          columns={columns as any}
          emptyText="No data found"
          data={filterCardList}
          rowKey="id"
          scroll={{ x: 1000 }}
          sticky={true}
          className="matrix"
          onHeaderRow={() => ({
            className: "header-title",
          })}
        />
        <Pagination
          page={currentPage}
          className="w-full mt-10"
          count={Math.ceil(totalCards / pageSize)}
          onChange={handlePageChange}
        />
      </div>

      <Modal
        open={activeCardDetail ? true : false}
        onClose={() => {
          setActiveCardDetail(null);
          getCardList();
        }}
        modalClass="w-full"
      >
        <CardDetail
          detail={activeCardDetail}
          isProcessingTeam={true}
          closePopup={() => setActiveCardDetail(null)}
        />
      </Modal>
    </div>
  );
};
export default UserManagementCard;
